import Http from '@/utils/http';
import { AppResponse } from '@/types';
import type { ILearningRecordListItem } from '@/types/models/learning-record';

// 获取学生信息
export const getCMACourseLearningRecord = (params: {
    year: number;
}): Promise<AppResponse<{ list: ILearningRecordListItem[]; studentId: number }>> =>
    Http.get('/student-learning/api/v1/analysis/cma-course/resource-complete', params);

// cma报告获取当前数据更新时间
export const getCmaReportUpdateTime = (): Promise<AppResponse<{ yearList: number[]; updateTime: string }>> =>
    Http.get('/student-learning/api/v1/analysis/cma-report/update-time');
